export default function OPTIMIZE_CATNAV() {
  // カテゴリリスト整形 カレントメニュー
  const content = location.pathname.replace(/^(\/[^/]+\/)(.+)?/,'$1'),
        $allLink = $('<div><h4><a/></h4></div>').attr({class:'title list_title1 block_title'})
  let   cateLink = $('.breadcrumbs li:eq(2) a').attr('href')
  cateLink = (cateLink && cateLink.search('mode=list') != -1 )? cateLink.replace(/main\.php/,''): null;
  $('a',$allLink).attr({href:content}).text('ALL');
  $('div.layout_b_pattern6').each((i,nav) => {
    $allLink.clone().prependTo( $('.list_cat',nav) );
    $(nav).currentMenu({
      url:cateLink||location.pathname+location.search
    });
  })
}